"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onEnter = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_1 = require("@main/common");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageCrewCarry_1 = require("@voyage/multi/voyageMessageCrewCarry");
var voyageMessageCrewCarry_sidecar_1 = require("@voyage/multi/voyageMessageCrewCarry-sidecar");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
function onEnter(obj, isFinalMove) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    if (!isFinalMove) {
        return;
    }
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        // if (diveCrew.isHolding(obj, EVoyageCarryableType.BattleRifle)) {
        var coffee = diveCrew_sidecar_1.diveCrew.getItemSafe(obj, voyageCarryableData_1.EVoyageCarryableType.Coffee);
        if (!coffee) {
            if (obj.heroState) {
                obj.heroState.coffeeSteps = 200;
            }
            voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Create,
                type: voyageCarryableData_1.EVoyageCarryableType.Coffee,
                crewId: obj.id,
                carryId1: common_1.createId(),
                carryId2: 0,
                i: obj.i,
                j: obj.j,
            });
        }
        else if (diveCrew_sidecar_1.diveCrew.isHolding(obj, voyageCarryableData_1.EVoyageCarryableType.Coffee)) {
            if (obj.heroState) {
                obj.heroState.coffeeSteps = 0;
            }
            voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Destroy,
                type: voyageCarryableData_1.EVoyageCarryableType.Coffee,
                crewId: obj.id,
                carryId1: coffee.id,
                carryId2: 0,
                i: obj.i,
                j: obj.j,
            });
        }
    }
    // if (!obj.carryable) {
    //   obj.carryable = voyageCarryable.create(EVoyageCarryableType.Coffee)
    //   voyageCarryable.moveToXY(obj.carryable, obj.x, obj.y)
    // } else if (
    //   obj.carryable &&
    //   obj.carryable.type === EVoyageCarryableType.Coffee
    // ) {
    //   voyageCarryable.kill(obj.carryable)
    //   obj.carryable = null
    // }
}
exports.onEnter = onEnter;
